import { useQuery } from '@tanstack/react-query'
import { fetchDemoSubmissions } from './api.js'

/**
 * `LGH-049`. No mutation, no invalidation — this screen only reads. "Real
 * time" here means "fresh on load/refresh", the same bar every other list
 * screen in this console already clears (`REQ-design-the-operator-console-
 * ux-audit`'s own retry-ceiling fix keeps a stuck request from hanging this
 * screen indefinitely, same as every sibling screen now).
 */
export function useDemoSubmissions() {
  return useQuery({
    queryKey: ['demo-submissions'],
    queryFn: fetchDemoSubmissions,
  })
}
